import getUser from './getUser'
import Leitores from '../leitores/Leitores'

const getLeitor = async () => {
  const user = await getUser()

  const { data } = await Leitores().show({
    'includes[user][id]': user.id,
    'includes[]': 'biblioteca'
  })

  if (data.data) {
    return data.data
  }
  return null
}
export default getLeitor
